// styles.js

import { Platform, Dimensions, StyleSheet } from 'react-native';

const screenWidth = Dimensions.get('window').width;
const isWeb = Platform.OS === 'web';
const isMobile = screenWidth < 768;


const styles = StyleSheet.create({
  pageContainer: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#121212',
  },
  menuItem: {
    color: '#ccc',
    fontSize: 16,
    marginVertical: 12,
    fontWeight: '400',
    fontFamily: 'System',
  },
  activeMenuItem: {
    color: '#00C7FF',
    fontWeight: '600',
  },
  sidebarLogo: {
    width: 320,
    height: 120,
    resizeMode: 'contain',
    marginBottom: 40,
    alignSelf: 'center',
  },
  mainContent: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 60, // Push content below the fixed header
    padding: 16,
  },
  heading: {
    fontSize: 36,
    fontWeight: '600',
    color: 'white',
    textAlign: 'center',
    marginBottom: 20,
  },
  paragraphContainer: {
    marginTop: 30,
    width: '90%',
  },
  paragraphWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 40,
  },
  imageLeft: {
    flexDirection: 'row-reverse',
  },
  imageRight: {
    flexDirection: 'row',
  },
  image: {
    width: 240,
    height: 240,
    resizeMode: 'contain',
    marginRight: 20,
  },
  textContainer: {
    flex: 1,
  },
  
  paragraphHeading: {
    fontSize: 22,
    color: '#00C7FF',
    fontWeight: 'bold',
    marginBottom: 10,
  },
  paragraph: {
    fontSize: 18,
    color: '#D4D4D4',
    lineHeight: 28,
    marginBottom: 24,
    textAlign: 'left',
  },
  /*
  successParagraphHeading: {
    fontSize: 20,
  fontWeight: 'bold',
  marginBottom: 8,
  textAlign: 'center',
},

successParagraph: {
  fontSize: 16,
  color: '#555',
  textAlign: 'center',
  lineHeight: 22,
},
*/
storyBlock: {
  marginBottom: 40,
  alignItems: 'center',
  paddingHorizontal: 20,
},

/*
storyImage: {
  width: '100%',
  height: 300,
  resizeMode: 'contain',
  marginVertical: 16,
  borderRadius: 10,

},

*/


imageWrapper: {
    width: isMobile ? '100%' : '40%',
    height: isMobile ? 300 :400 ,      // No fixed height on mobile
    aspectRatio: isMobile ? 4 / 5 : 4 / 5, // 4:5 aspect ratio on mobile
    borderRadius: 16,
    overflow: 'hidden',        // ✅ clip rounded corners
    backgroundColor: 'black',  // ✅ so shadow looks clean
    elevation: 4,              // ✅ Android shadow
    shadowColor: '#000',       // ✅ iOS shadow
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 6,
    marginVertical: 20,
  },

  imageWrapper1: {
    width: isMobile ? '100%' : '40%',
    height: isMobile ? 500 :600 ,      // No fixed height on mobile
    aspectRatio: isMobile ? 4 / 5 : 4 / 5, // 4:5 aspect ratio on mobile
    borderRadius: 16,
    overflow: 'hidden',        // ✅ clip rounded corners
    backgroundColor: 'black',  // ✅ so shadow looks clean
    elevation: 4,              // ✅ Android shadow
    shadowColor: '#000',       // ✅ iOS shadow
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 6,
    marginVertical: 20,
  },
  storyImage: {
    width: '100%',
    height: '100%',            // ✅ image takes full container
  },

  /*
  footerLinks: {
    flexDirection: 'row',
    flexWrap: 'wrap',  
    justifyContent: 'center',
    marginBottom: 10,
  },
  */
 
  footerText: {
    color: '#ffffff',
    fontSize: 14,
    marginHorizontal: 10,
    lineHeight: 22,
  },
  footerLinks: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between', // still good here
    maxWidth: 800,
    paddingHorizontal: 20,
    alignSelf: 'center',
    marginTop: 30,
  },
  footerTextWrapper: {
    // Use fixed pixel width for more horizontal space
    width: isWeb ? 360 : '48%',  // ⬅️ wider on web = more spacing between
    marginBottom: 20,
  },
  socialIcons: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  icon: {
    marginHorizontal: 10,
  },
  contactDetails: {
    marginTop: 30,
    width: '90%',
    alignItems: 'center',
  },
  contactText: {
    fontSize: 18,
    color: '#D4D4D4',
    marginBottom: 10,
    textAlign: 'center',
  },
  contactLink: {
    color: '#00C7FF', // Highlight the email in blue
  },
  logo: {
    width: 750, // Adjust size as needed
    height: 250, // Adjust size as needed
    resizeMode: 'contain',
    marginBottom: 20,
  },

  // Home page
  
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center', 
    backgroundColor: 'black',
    paddingHorizontal: 20,
  },
  
  heading: {
    fontSize: 40,             // match About Us heading
    fontWeight: '600',
    color: '#ffffff',
    textAlign: 'center',
    marginBottom: 20,
  },
  description: {
    fontSize: 18,
    color: '#D4D4D4',         // match paragraph text color
    textAlign: 'center',
    maxWidth: 600,
    marginBottom: 20,
    lineHeight: 28,
  },
  button: {
    backgroundColor: 'transparent',
    paddingVertical: 14,
    paddingHorizontal: 36,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: '#00C7FF',
    alignItems: 'center',
  },
  buttonText: {
    fontSize: 18,
    color: '#00C7FF',
    fontWeight: '600',
  },
  toggleButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 10,
  },
  menuItemWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 14,
    paddingHorizontal: 10,
  },
  menuItemText: {
    color: '#ccc',
    fontSize: 16,
    marginLeft: 12,
  },
  menuButton: {
    position: 'absolute',
    top: 40,
    left: 20,
    zIndex: 5,
  },

  sidebar: {
    backgroundColor: '#0A0A0A',
    paddingTop: 50,
    paddingHorizontal: 10,
    borderRightWidth: 0,
    borderColor: '#222',
  },
  toggleIcon: {
    marginBottom: 20,
    alignItems: 'center',
  },
  menuItemWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 15,
  },
  menuItem: {
    color: '#ccc',
    fontSize: 16,
    marginLeft: 10,
  },
  activeMenuItem: {
    color: '#00C7FF',
    fontWeight: 'bold',
  },
  closeIcon: {
    position: 'absolute',
    top: 12,
    right: 12,
    padding: 8,
    zIndex: 999,
  },

openSidebarButton: {
  position: 'absolute',
  top: 12,
  left: 12,
  padding: 8,
  zIndex: 999,
},

'@media (max-width: 768px)': {
    container: {
      justifyContent: 'flex-start', // Align to the top on smaller screens
      paddingTop: 40,               // Add space on top for mobile devices
    },
    heading: {
      fontSize: 24,  // Slightly smaller heading on mobile
    },
    description: {
      fontSize: 16,  // Smaller text on mobile
    },
  },
header: {
  position: 'absolute', // Or 'fixed' on web
  top: 0,
  left: 0,
  right: 0,
  zIndex: 10,
  height: 60,
  backgroundColor: '#0A0A0A', // Or match your background
  paddingHorizontal: 16,
  paddingTop: 12,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottomWidth: 0,
  borderBottomColor: '#222', // Optional separator
},

logoTitle: {
  fontSize: 20,
  fontWeight: 'bold',
  color: '#fff',
},

sidebarIconContainer: {
  justifyContent: 'center',
  alignItems: 'center',
},

sidebarIconWrapper: {
  backgroundColor: '#1a1a1a',
  borderRadius: 8,
  padding: 8,
},

 fixedHeader: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 999,
    elevation: 4,
    backgroundColor: '#fff',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 3,
  },

scrollContainer: {
  paddingTop: 60, // Adjust depending on header height
},

 horizontalContainer: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: 10,
  paddingHorizontal: 10,
  flexWrap: 'wrap',
},

serviceCard: {
  flex: 1,
  minWidth: 250,
  maxWidth: '100%',
  padding: 10,
  backgroundColor: '#111',
  borderRadius: 10,
  borderWidth: 1,
  borderColor: '#333',
  marginBottom: 10,
},

serviceTitle: {
  fontSize: 20,
  fontWeight: 'bold',
  color: '#fff',
  marginBottom: 5,
},

serviceText: {
  fontSize: 16,
  color: '#ccc',
},
cardRow: {
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 8,
},

serviceIcon: {
  width: 40,
  height: 40,
  marginRight: 8,
  resizeMode: 'contain',
},


  partnersSection: {
    marginTop: 30,
    alignItems: 'center', // Center align the section
    marginBottom: 20, // Optional: adds spacing below the section
  },
  partnersList: {
    marginTop: 10,
    flexDirection: 'row', // Ensure cards are aligned horizontally
  },
  partnerStack: {
    width: 120, // or match image size
    height: 120,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative', // So children can be absolute
  },
  partnerCard: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  partnerImage: {
    width: 200,
    height: 200,
    resizeMode: 'contain',
  },





});

export default styles;
